module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/office-studio-mobile-2711fa7d96a5a9a2e725cedb89ac7a5e.png";